<template>
  <div class='rkld'>
    <div class='rkldRight'>
      <div class='rkldRightContent'>
        <el-tabs
          v-model='editableTabsValue'
          type='card'
          @edit='handleTabsEdit'
        >
          <el-tab-pane label='原料维护' name='1'>
            <!--查询条件-->
            <div class='searchTj'>
              <div class='searchTjHead'>
                <span>查询条件</span>
                <i class="searchDomw" @click="showSearch = !showSearch" :class="showSearch==true?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                <!-- <el-button
                  style='
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    '
                  type='text'
                  @click='Reset'
                >
                  <i class='el-icon-refresh'></i>
                  刷新页面
                </el-button> -->
              </div>
              <el-form :model='form' class='searchTjContent' v-show="showSearch">
                <div
                  class='searchTjContentDiv'
                >
                                    <span class='searchTjContentDivSpan'
                                    >材料名称</span
                                    >
                  <el-input
                    v-model='form.materialName'
                    placeholder='请输入'
                    class='searchTjContentDivInput'
                  ></el-input>
                </div>
                <div
                  class='searchTjContentDiv'
                  v-show='quanbu'
                >
                  <el-button
                    type='primary'
                    icon='el-icon-search'
                    @click='query'
                    class="searchBtns"
                  >查询
                  </el-button
                  >
                </div>

                <div
                  class='searchTjContentDiv'
                >
                  <el-button
                    type='info'
                    icon='el-icon-delete'
                    @click='resert'
                  >清除条件
                  </el-button
                  >
                </div>
                <!-- <div class='arrowDown' @click='showSearch'>
                  <i
                    class='el-icon-arrow-down'
                    style='color: #000'
                  ></i>
                </div> -->
              </el-form>
            </div>

            <!--按钮-->
            <div class='searchButtonDiv' v-if='quanbu'>
              <div class='searchButtonDivLeft'>
                <el-button-group>
                  <el-button
                    icon='el-icon-plus'
                    type='success'
                    class="openBtns"
                    @click="showDialog('新增')"
                  >新增
                  </el-button
                  >
                  <el-button
                    icon='el-icon-delete'
                    type='danger'
                    @click='batchDelete'
                  >批量删除
                  </el-button
                  >
                </el-button-group>
              </div>
              <div class='searchButtonDiveRight'>
                <el-button-group>
                  <el-button
                    type='primary'
                    icon='el-icon-refresh'
                    class="dropRests"
                    @click.native='resertTable'
                  ></el-button>
                  <!-- <el-button type="primary"> -->
                  <el-dropdown
                    class='dropdown'
                    trigger='click'
                    :hide-on-click='false'
                  >
                                        <span class='el-dropdown-link'>
                                            <i
                                              class='el-icon-s-grid el-icon--right'
                                              style='color: #fff'
                                            ></i>
                                            <i
                                              class='el-icon-arrow-down el-icon--right'
                                            ></i>
                                        </span>
                    <el-dropdown-menu slot='dropdown'>
                      <el-dropdown-item>
                        <template>
                          <el-checkbox-group
                            v-model='checkList'
                            :min='1'
                            text-color='#000000'
                            @change='tableShow'
                          >
                            <el-checkbox
                              label='序号'
                            >序号
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='材料名称'
                            >材料名称
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='材料规格'
                            >材料规格
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='单价'
                            >单价
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='重量'
                            >重量
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='总价'
                            >总价
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='操作'
                            >操作
                            </el-checkbox
                            >
                            <br />
                          </el-checkbox-group>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- </el-button> -->
                </el-button-group>
              </div>
            </div>

            <!--表格-->
            <div>
              <el-table
                ref='multipleTable'
                :data='myData'
                tooltip-effect='dark'
                @row-click='openDetails'
                highlight-current-row
                @selection-change='handleSelectionChange'
                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                border
              >
                <el-table-column
                  type='selection'
                  width='80'
                  align='center'
                  @selection-change='handleSelectionChange'
                >
                </el-table-column>
                <el-table-column
                  type='index'
                  width='100'
                  label='序号'
                  header-align='center'
                  align='center'
                  v-if='no1'
                ></el-table-column>
                <el-table-column
                  prop='materialName'
                  label='材料名称'
                  align='center'
                  v-if='no2'
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop='materialSpecs'
                  label='材料规格'
                  align='center'
                  show-overflow-tooltip
                  v-if='no3'
                >
                </el-table-column>
                <el-table-column
                  prop='materialPrice'
                  label='单价'
                  align='center'
                  show-overflow-tooltip
                  v-if='no4'
                >
                </el-table-column>
                <el-table-column
                  prop='materialWeight'
                  label='重量'
                  width='200'
                  align='center'
                  show-overflow-tooltip
                  v-if='no5'
                >
                </el-table-column>
                <el-table-column
                  prop='materialSeparately'
                  label='总价'
                  width='180'
                  align='center'
                  show-overflow-tooltip
                  v-if='no6'
                >
                </el-table-column>
                <el-table-column
                  prop='operation'
                  label='操作'
                  align='center'
                  width='280px'
                  v-if='no7'
                >
                  <template slot-scope='scope'>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='查看'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-chakan tabBtn'
                        @click="
                                                    showDialog(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='编辑'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-bianji3 tabBtn'
                        @click="
                                                    showDialog(
                                                        '编辑',
                                                        scope.row
                                                    )
                                                "
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='删除'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-icon7 tabBtn'
                        @click='deleteItem(scope.row)'
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page='currentPage'
                :page-sizes='[10, 20, 50, 100]'
                :page-size='10'
                layout='total, sizes, prev, pager, next, jumper'
                :total='total'
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      :title='dialogTile'
      :visible.sync='visVisible'
      width='990px'
      @close='clearadddata'
    >
      <el-form
        ref='addform'
        :model='addform'
        :rules='addformRules'
        label-width='110px'
        size='mini'
      >
        <el-form-item label='材料名称：' prop='materialName'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model='addform.materialName'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='材料规格：' prop='materialSpecs'>
          <!--          <el-input-->
          <!--            :disabled="dialogTile == '查看'"-->
          <!--            v-model='addform.materialSpecs'-->
          <!--            placeholder='请输入'-->
          <!--          ></el-input>-->
          <el-select
            v-model='addform.materialSpecs'
            :disabled="dialogTile == '查看'"
            placeholder='请选择材料规格'
            style='width: 100%'
          >
            <el-option label='斤' value='斤'></el-option>
            <el-option label='公斤' value='公斤'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='单价：' prop='materialPrice'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model.number='addform.materialPrice'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='重量：' prop='materialWeight'>
          <el-input
            :disabled="dialogTile == '查看'"
            v-model.number='addform.materialWeight'
            @input='price'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='总价：' prop='materialSeparately'>
          <el-input
            disabled
            v-model.number='addform.materialSeparately'
            placeholder='自动计算'
          ></el-input>
        </el-form-item>
        <el-form-item label='上传图片：' prop='materialPhoto'>
          <template v-if="dialogTile === '查看'">
            <el-image
              style='width: 120px; height: 120px; margin: 10px'
              :src='addform.materialPhoto'
            >
            </el-image>
          </template>
          <el-upload
            v-else
            :action='actionUrl'
            list-type='picture-card'
            :on-success='handleAvatarSuccess'
            :before-upload='beforeAvatarUpload'
            :on-preview='handlePicturePreview'
          >
            <i class='el-icon-plus'></i>
          </el-upload>
          <el-dialog
            :visible.sync='dialogVisible1'
            append-to-body
            style='border-bottom: none'
          >
            <img width='100%' :src='dialogImageUrl' alt />
          </el-dialog>
        </el-form-item>
        <!--        <el-form-item label='是否入库：' prop='isStorage'>-->
        <!--          <el-radio-->
        <!--            v-model='addform.isStorage'-->
        <!--            label='0'-->
        <!--            :disabled="dialogTile == '查看'"-->
        <!--          >是-->
        <!--          </el-radio-->
        <!--          >-->
        <!--          <el-radio-->
        <!--            v-model='addform.isStorage'-->
        <!--            label='1'-->
        <!--            :disabled="dialogTile == '查看'"-->
        <!--          >否-->
        <!--          </el-radio-->
        <!--          >-->
        <!--        </el-form-item>-->
      </el-form>
      <div slot='footer' v-if="dialogTile != '查看'">
        <el-button
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click='saveadddata'
        >保存
        </el-button>
        <el-button type='info' size='small' @click='clearadddata'
        >关闭
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request.js'
import { conflictMediationApi2 } from '@/api/http.js'
import request2 from '@/utils/request2.js'
import { post, get } from '@/api/requrestHttp.js'
import baseURL from '@/api/baseURL'

export default {
  data() {
    return {
      imageUrl: '',
      selectedData: [],
      // 图片地址
      actionUrl:
        baseURL + '/sqyl/controller/uploadController/info/uploadPhoto',
      visVisible: false,
      // 表单验证
      addformRules: {
        materialName: [
          {
            required: true,
            message: '请输入材料名称',
            trigger: 'blur'
          }
        ],
        materialSpecs: [
          {
            required: true,
            message: '请输入材料规格',
            trigger: 'blur'
          }
        ],
        materialPrice: [
          { required: true, message: '请输入单价', trigger: 'blur' }
        ],
        materialWeight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        materialSeparately: [
          { required: true, message: '请输入总价', trigger: 'blur' }
        ]
      },
      // 图片
      photo: [],
      addform: {
        materialName: '',
        materialSpecs: '',
        materialPrice: '',
        materialWeight: '',
        materialSeparately: '',
        materialPhoto: '',
        isStorage:0,
      },
      checkList: [
        '序号',
        '材料名称',
        '材料规格',
        '单价',
        '重量',
        '总价',
        '操作'
      ],
      quanbu: true,

      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      timer: '', //定义一个定时器的变量
      showSearch: true,
      editableTabsValue: '1',
      myData: [],
      pageNo: 1,
      pageSize: 10,
      form: {
        materialName: '',
        pageNo: 1,
        pageSize: 10
      },
      dialogTile: '',
      dialogImageUrl: '',
      dialogVisible1: false,
      // 列表显示
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true
    }
  },
  inject: ['reload'], //注入
  methods: {
    // 列表项显示
    tableShow() {
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == '序号') == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '材料名称') == -1
        ) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '材料规格') == -1
        ) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (this.checkList.findIndex((obj) => obj == '单价') == -1) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (this.checkList.findIndex((obj) => obj == '重量') == -1) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == '总价') == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (this.checkList.findIndex((obj) => obj == '操作') == -1) {
          this.no7 = false
        } else {
          this.no7 = true
        }
      }
    },
    price() {
      let monye = this.addform.materialWeight * this.addform.materialPrice
      this.addform.materialSeparately = monye
      console.log('111')
    },
    // 新增
    showDialog(type, date) {
      this.addform = {
        isStorage:0,
      }
        this.visVisible = true
      this.dialogTile = type
      this.resetForm('addform')
      switch (type) {
        case '新增':
          break
        case '查看':
          this.look(date)
          break
        case '编辑':
          this.look(date)
          break
      }
    },
    // 查看
    async look(date) {
      await request({
        url: '/sqyl/admin/material/info/findById',
        method: 'POST',
        data: { id: date.id }
      }).then((res) => {
        console.log(res)
        this.addform = res.content
        console.log(this.addform)
      })
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    //自定义图片上传
    handleAvatarSuccess(res, file) {
      console.log(res.content);
      this.imageUrl = res.content
      this.addform.materialPhoto = res.content
    },
    // 删除
    deleteItem(date) {
      this.$confirm('确认永久删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/sqyl/admin/material/info/deleteById',
          method: 'POST',
          data: { id: date.id }
        }).then((res) => {
          console.log(res)
          this.showlist()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      })
    },
    clearadddata() {
      this.visVisible = false
      this.addform = {}
      //  this.$refs["addform"].resetFields();
    },
    // 保存
    saveadddata() {
      this.$refs.addform.validate((valid) => {
        if (valid) {
          let params = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            ...this.addform,
            qujiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .qujiId,
            shengjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shengjiId,
            shijiId: JSON.parse(localStorage.getItem('czUserInfo'))
              .shijiId,
            stationId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).stationId,
            shequjiId: JSON.parse(
              localStorage.getItem('czUserInfo')
            ).shequjiId
          }
          params = Object.assign({}, params)
          request({
            url: '/sqyl/admin/material/info/insert',
            method: 'POST',
            data: params
          }).then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.clearadddata()
              // this.visVisible = false
            }
            this.showlist()
          })
        }
      })
    },

    //每页请求数据
    handleSizeChange(val) {
      console.log('editableTabs=>', this.editableTabs)
      this.pageSize = val
      this.showlist()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: 'success'
      })
    },
    // 查询重置
    resert() {
      this.form.materialName = ''
      this.showlist()
    },
    //请求第几数据
    handleCurrentChange(val) {
      console.log('editableTabs=>', this.editableTabs)
      this.pageNo = val
      this.showlist()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: 'success'
      })
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleTabsEdit(targetName, action) {
      this.showlist(e)
    },
    // 行点击选中
    openDetails(row, event, column, cell) {
      this.$refs.multipleTable.toggleRowSelection(row)
      this.showtext = !this.showtext
      this.row = row
      this.column = column
    },
    handleSelectionChange(data) {
      this.selectedData = data
    },
    batchDelete() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.$confirm('确认永久删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            val.forEach(function(item, index) {
              request({
                url: '/sqyl/admin/material/info/deleteById',
                method: 'POST',
                data: { id: item.id }
              })
            })
          })
          .then(() => {
            this.showlist()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
      } else {
        this.$confirm('请选择要删除的项。', '提示')
      }
      this.$refs.multipleTable.clearSelection()
    },
    //拿到列表数据
    async showlist(e) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params, {
        ...e
      })
      await request({
        url: '/sqyl/admin/material/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        if (res.content == null) {
          this.myData = []
          this.total = 0

        }
        this.myData = res.content.list
        this.total = res.content.count
      })
    },

    // 查询
    query() {
      post('/sqyl/admin/material/info/findList', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        materialName: this.form.materialName,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }).then((res) => {
        if (res.content !== null) {
          this.myData = res.content.list
          this.total = res.content.count
        } else {
          this.myData = []
        }
      })
    },

    // 表单重置
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },

    // 重置
    Reset() {
      this.reload()
    },

    // 表单刷新
    resertTable() {
      this.showlist()
      this.checkList = [
        '序号',
        '材料名称',
        '材料规格',
        '单价',
        '重量',
        '总价',
        '操作'
      ]
      this.tableShow()
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },

    // 预览图片
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    }
  },
  created() {
    this.showlist()
  }
}
</script>
<style lang='less' scoped>
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 254px);
  background-color: #ffffff;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.rkldRightHeadRightRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  cursor: pointer;
  background: rgba(252, 254, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 19px;
  box-sizing: border-box;
  padding: 7px 20px;
  margin-left: 20px;
  color: #444;
  font-size: 12px;
}

.rkldRightHeadRightRight span {
  width: 1px;
  height: 20px;
  margin: 0 14px;
  background: #ccc;
  opacity: 0.6;
}

.rkldRightHeadRightRight div {
  display: flex;
  align-items: center;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  margin:5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;

  .el-button {
    border-radius: 4px;
  }
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px);
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}

/deep/ .el-button {
  margin-left: 0px;
  border-radius: 0px;
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

/deep/ .el-submenu__title {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
  border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
.el-tabs--card
> .el-tabs__header
/deep/
.el-tabs__item.is-active.is-closable {
  color: #0e2d5f;
}

/deep/ .el-submenu {
  width: 234px !important;
}

/deep/ .tabBtn {
  margin: 0px;
}

.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.searchButtonDivLeft {
  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
  }

  /deep/ .el-button:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  /deep/ .el-button:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;

    i,
    span {
      color: #fff;
    }
  }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}

/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

/deep/ .el-dialog .el-dialog__header {
  border-bottom: 1px solid #e4e4e4;
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
  background-color: #f5f5f5;
}
</style>
